<template>
  <Card>
    <h1 slot="Title">States of an Appropriation Examples</h1>
    <div slot="MainContent">
      <p>
        <b>Appropriation of Funds:</b> 202011D20 <br>
        <b>Unexpired:</b> 1 Oct 2019 - 30 Sep 2020 <br>
        <b>Expired:</b> 1 Oct 2020 - 30 Sep 2025 <br>
        <b>Closed:</b> 1 Oct 2025 - Indefinitely <br>
      </p>
      <p>
        <b><u>202011D20</u></b>   A76VV 131096QLOG 6100.2617 WBS, Internal Order or Cost Center 1000000067 021001
      </p>
    </div>
    <div slot="Notes">
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); font-weight: bold;">States of an Appropriation Examples</span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">Ref to 37-100&gt;22-FY - 3</span></span></p>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;">&bull;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">&nbsp;Unexpired:&nbsp;1 Oct 2019 - 30 Sep 2020&nbsp;Obligate and disburse</span></span></div>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;">&bull;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">&nbsp; &nbsp;Expired:&nbsp;1 Oct 2020 - 30 Sep 2025&nbsp;Disburse only. May make adjustment to obligation with approval from major command</span></span></div>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;">&bull;</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">&nbsp; &nbsp;Closed: 1 Oct 2025 - Indefinitely &nbsp; Unobligated and unliquidated balances will be cancelled. Collections received will be deposited into a Miscellaneous Receipt Account (021R3210.0001)</span></span></div>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255);">&nbsp;</span></p>
    </div>
  </Card>
</template>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'StatesofanAppropriationExamples',
  
  data() {
    return {
    }
  }
  
}
</script>